<script lang="ts" setup>
import { CrossIcon } from "@/Components/Icons/";

export interface ImagePreviewProps {
  imageSrc?: string;
}

const props = defineProps<ImagePreviewProps>();

const emit = defineEmits<{
  (event: "onClickClosePreview"): void;
}>();

const onClickClosePreview = () => {
  emit("onClickClosePreview");
};
</script>

<template>
  <div class="image__preview">
    <div class="image__preview__icon" @click="onClickClosePreview">
      <CrossIcon color="content-inverse" />
    </div>

    <div class="image__preview__image" :style="{ 'background-image': `url(${props.imageSrc})` }" />
  </div>
</template>

<style lang="scss">
.image__preview {
  @include colors.bg(background, base);

  width: 100%;
  height: 100%;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;

  &__icon {
    @include colors.bg(content, high);

    width: $space-9;
    height: $space-9;
    position: fixed;
    top: $space-6;
    right: $space-6;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 11px;
  }

  &__image {
    height: 100%;
    width: 100%;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
  }
}
</style>
